import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import {DashboardAPI, getTeamsAPI, DashboardTeamFilterAPI, getTeamCampaignListAPI, getFilterCallerListAPI, DashboardFilterAPI, TeamPerformanceAPI} from "./../../API/Sales/DashboardAPI";

import Layout from "./Layout";
import ContentLoader from "./../../utils/ContentLoader";
import "./../../Public/css/sales_dashboard.css";
import TeamPerformance from "./TeamPerformance";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactSelect from 'react-select';
import { format } from "date-fns";


const Dashboard = () =>{

	const [freshleadcount, setFreshLeadCount] = useState(0);
	const [pendingfollowupcount, setPendingFollowupCount] = useState(0);
	const [todayfollowupcount, setTodayFollowupCount] = useState(0);
	const [warmcount, setWarmCount] = useState(0);
	const [totalleadcount, setTotalLeadCount] = useState(0);
	const [totalcount, setTotalCount] = useState(0);
	const [isstatreload, setIsStatReload] = useState(false);
	const [loggedname, setLoggedName] = useState("");	
	const [teamsummary, setTeamSummary] = useState([]);
	const [teams, setTeams] = useState([]);
	const [campaigns, setCampaigns] = useState([]);
	const [callers, setCallers] = useState([]);
	const [filterteam, setFilterTeam] = useState("");
	const [filtercampaign, setFilterCampaign] = useState("");
	const [filtercaller, setFilterCaller] = useState("");
	const [filterstartdate, setFilterStartDate] = useState("");
	const [filterenddate, setFilterEndDate] = useState("");
	const [filterparam, setFilterParam] = useState("");
	const [selectedTeamId, setSelecttedTeamId] = useState("");
	const [expandedteams, setExpandedTeams] = useState({});
	const [loader, setLoader] = useState(false);

	const [createdstartdate, setCreatedStartDate] = useState(null);
	const [createdenddate, setCreatedEndDate] = useState(null);

	const [assignedstartdate, setAssignedStartDate] = useState(null);
	const [assignedenddate, setAssignedEndDate] = useState(null);

	const [filterteamstartdate, setFilterTeamStartDate] = useState(null);
	const [filterteamenddate, setFilterTeamEndDate] = useState(null);

	const [filtersStored, setFiltersStored] = useState(null);
	const [topfiltersDraft, setTopFiltersDraft] = useState({ 
                                                    filterteam: "",
                                                    filtercaller: ""
                                                    /*filtercreatedstartdate: "",
                                                    filtercreatedenddate: "",
                                                    filterassignedstartdate: "",
                                                    filterassignedenddate: ""*/
                                                });
	

	useEffect(() => {
		if (!selectedTeamId) return;

		setExpandedTeams((prev) => ({
			...prev,
			[selectedTeamId]: true,
		}));

	}, [selectedTeamId]);


	const current = moment();

	useEffect(()=>{

		const userinfo = localStorage.getItem("userinfo");

        if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
            
        }

		//getTeamsAPI(setTeams);

	}, []);

	useEffect(()=>{

		getTeamsAPI(setTeams);

	}, [])

	useEffect(() =>{
		console.log('Sales dahboard');

		//const token = localStorage.getItem("cpmstoken");

		//if (!token) return;

		DashboardAPI(setLoader, setTotalLeadCount, setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, setWarmCount, setTeamSummary, setIsStatReload);

		//DashboardAPI(setCampaignsList, setTeamCount, setCampaignCount, setLeadCount, setConvertedLeadCount, setLoading);
		//LeadPerformanceReportAPI(setLeadPerformSeries, setLeadPerformOptions, setShowLeadPerformChart, "");

	}, [isstatreload]);

	/*const handleSelectCampaign = (e) =>{
		
		const filterparams = new URLSearchParams();

        if(e.target.value > 0)
        {
            filterparams.append('filtercampaignid', e.target.value);

			LeadPerformanceReportAPI(setLeadPerformSeries, setLeadPerformOptions, setShowLeadPerformChart, filterparams);
        }
		else
		{
			LeadPerformanceReportAPI(setLeadPerformSeries, setLeadPerformOptions, setShowLeadPerformChart, "");
		}
		
	}*/

	useEffect(() => {
                
        console.log("Step 2");
        const filterparams = new URLSearchParams();
        
        
        if (filtersStored)
        {
            console.log("Step 3");
                
            Object.keys(filtersStored).forEach(key => {
                if (filtersStored[key]) {
                    filterparams.append(key, filtersStored[key]);
                }
            });
        }

        console.log("Step 4");

        //params.append("page", currentPage);
        //params.append("per_page", perpagedata);
        console.log(">>>>>" + JSON.stringify(filterparams));

        //DashboardAPI(setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading, params);

        DashboardFilterAPI(filterparams, setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, setWarmCount, setTotalLeadCount, setFilterParam);

        //DashboardAPI(setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading, params);

        //DashboardFilterAPI(params, setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setLoading);

    }, [filtersStored]);

	const handleReloadStats = () =>{

		setIsStatReload(true);

		//DashboardAPI(setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, setIsStatReload, setWarmCount);
	}

	const handleFilterTeam = (selteam) =>{
		setFilterTeam(selteam);

		const teamid = selteam?.value ?? "";

		setTopFiltersDraft(prev => ({
                                ...prev,
                                filterteam: teamid
                            }));

		//getTeamCampaignListAPI(e.target.value, setCampaigns);
		getFilterCallerListAPI(teamid, setCallers);
	}

	/*const handleFilterCampaign = (e) =>{
		setFilterCampaign(e.target.value);

		getFilterCallerListAPI(e.target.value, setCallers);
	}*/

	const handleFilterCaller = (selcaller) =>{
		setFilterCaller(selcaller);

		const callerid = selcaller?.value ?? "";

		setTopFiltersDraft(prev => ({
                                ...prev,
                                filtercaller: callerid
                            }));
	}

	const handleStartDate = (e) =>{
		setFilterStartDate(e.target.value);
	}

	const handleEndDate = (e) =>{
		setFilterEndDate(e.target.value);
	}

	/*const handleStatsFilter = () =>{
		
		const params = { "teamid": filterteam };

		DashboardTeamFilterAPI(setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, params);
	}*/

	const handleFilterDashboardCounts = (e) =>{

		console.log('Filter Team====' + filterteam);
        console.log('Filter Caller====' + filtercaller);
        //console.log('Filter Start Date====' + filterstartdate);
        //console.log('Filter End Date====' + filterenddate);

        setFiltersStored({ ...topfiltersDraft });
	}

	/*const handleFilterDashboardCounts = () =>{

		const filterparams = new URLSearchParams();

        if(filterteam)
        {
            filterparams.append('team_id', filterteam);
        }

		if(filtercampaign)
        {
            filterparams.append('campaign_id', filtercampaign);
        }

        if(filtercaller)
        {
            filterparams.append('caller_id', filtercaller);
        }

        if(filterstartdate)
        {
            filterparams.append('start_date', filterstartdate);
        }

		if(filterenddate)
        {
            filterparams.append('end_date', filterenddate);
        }

		DashboardFilterAPI(filterparams, setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, setWarmCount, setFilterParam);
	}*/

	/*const handleFilterReset = () =>{
		setFilterTeam("");
		setFilterCampaign("");
		setFilterCaller("");
		setFilterStartDate("");
		setFilterEndDate("");

		handleReloadStats();
	}*/

	const handleClearFilterDashboard = () =>{

		setFilterTeam("");
		setFilterCaller("");
		//setFilterStartdate("");
		//setFilterEnddate("");

		setCreatedStartDate("");
        setCreatedEndDate("");

        setAssignedStartDate("");
        setAssignedEndDate("");

		setTopFiltersDraft({
					filterteam: "",
                    filtercaller: "",
                    filtercreatedstartdate: "",
                    filtercreatedenddate: "",
                    filterassignedstartdate: "",
                    filterassignedenddate: ""
        });

        setFiltersStored(null);

        handleReloadStats();

		//DashboardAPI(setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading, null);
	}

	/*const handleCreatedDateRange = (crdates) => {

        console.log("Created Dates====" + crdates);

        if(!crdates || (!crdates[0] && !crdates[1]))
        {
            
            console.log("created false condition");
            
            setCreatedStartDate("");
            setCreatedEndDate("");

            setTopFiltersDraft(prev => ({
                                ...prev,
                                filtercreatedstartdate: "",
                                filtercreatedenddate: ""
                            }));
        }
        else
        {
            console.log("created true condition");
            
            const [startdate, enddate] = crdates;

            setCreatedStartDate(startdate);
            setCreatedEndDate(enddate);

            setTopFiltersDraft(prev => ({
                                ...prev,
                                filtercreatedstartdate: format(startdate, "yyyy-MM-dd"),
                                filtercreatedenddate: format(enddate, "yyyy-MM-dd")
                            }));

        }

    }*/

    /*const handleAssignedDateRange = (assdates) => {

        console.log("Assigned Dates====" + assdates);

        if(!assdates || (!assdates[0] && !assdates[1]))
        {
            
            console.log("created false condition");
            
            setAssignedStartDate("");
            setAssignedEndDate("");

            setTopFiltersDraft(prev => ({
                                ...prev,
                                filterassignedstartdate: "",
                                filterassignedenddate: ""
                            }));
        }
        else
        {
            console.log("created true condition");
            
            const [startdate, enddate] = assdates;

            setAssignedStartDate(startdate);
            setAssignedEndDate(enddate);

            setTopFiltersDraft(prev => ({
                                ...prev,
                                filterassignedstartdate: format(startdate, "yyyy-MM-dd"),
                                filterassignedenddate: format(enddate, "yyyy-MM-dd")
                            }));

        }

    }*/

    const handleTeamStatDateRange = (seldates) => {

        console.log("Team Stats Dates====" + seldates);

        if(!seldates || (!seldates[0] && !seldates[1]))
        {
            
            console.log("team stats false condition");

            setFilterTeamStartDate("");
            setFilterTeamEndDate("");
            TeamPerformanceAPI(setTeamSummary, null);
           	
        }
        else
        {
            console.log("team stats true condition");

            const [startdate, enddate] = seldates;

            setFilterTeamStartDate(startdate);
            setFilterTeamEndDate(enddate);

            if (startdate && enddate) 
           	{
           		const datefilter = { filterstartdate:  format(startdate, "yyyy-MM-dd"), filterenddate: format(enddate, "yyyy-MM-dd") }

        		TeamPerformanceAPI(setTeamSummary, datefilter);
    		}
            

        }

    }

    const handleFilterReset = () =>{
    	
    }


    return(
	<Layout>
		<div className="content">
			<div class="welcome-wrap mb-4">
				<div class="d-flex align-items-center justify-content-between flex-wrap crm-welcome-bar">
					<div class="mb-3">
						<h2 class="mb-1 text-white">Welcome {loggedname}</h2>
						<p class="text-light">As of {current.format('DD MMMM YYYY')} {current.format('hh:mm A')}</p>
					</div>
					<div class="d-flex align-items-center flex-wrap mb-1 crm-top-actions">
						<button type="button" class="btn btn-light btn-md mb-2 mx-2" onClick={handleReloadStats}>Refresh</button>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12">
					<div className="page-header">
						<div className="align-items-center ">
							<div className="col-md-12 ms-auto">
								<div className="d-flex title-head crm-filter-row">
									<div className="crm-filter-item">
										<ReactSelect className="" value={filterteam} onChange={handleFilterTeam} options={teams} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Team"></ReactSelect>
									</div>									

									<div className="crm-filter-item">
										<ReactSelect className="" value={filtercaller} onChange={handleFilterCaller} options={callers} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Caller"></ReactSelect>
									</div>

									{/*<div className="crm-filter-item">
										<DatePicker className="form-control" selected={createdstartdate} onChange={ handleCreatedDateRange } startDate={createdstartdate} endDate={createdenddate} selectsRange isClearable placeholderText="Created Date" />
									</div>
									<div className="crm-filter-item">
										<DatePicker className="form-control" selected={assignedstartdate} onChange={ handleAssignedDateRange } startDate={assignedstartdate} endDate={assignedenddate} selectsRange isClearable placeholderText="Assigned Date" />
									</div>*/}

									<div className="crm-filter-item button-filter me-2">
										<button type="button" className="btn btn-success me-2" onClick={handleFilterDashboardCounts}>
											<i className="ti ti-search me-2"></i> Apply
										</button>
										
										<button type="button" className="btn btn-dark" onClick={handleFilterReset}>
											<i className="ti ti-restore me-2"></i>Clear Filter
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row crm-stats-row crm-stats-row-4">
				{/*<div className="crm-stat-col">
					<div class="card total">
						<div class="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div class="fs-25 fw-semibold widget-text text-center">{totalleadcount}</div>
								<div class="text-body-secondary fw-semibold widget-heading">Total Leads</div>
							</div>
						</div>
						<div class="card-footer px-3 py-2">
							<div class="footer-content">
								<a class="btn-block text-body-secondary d-flex justify-content-between align-items-center" href="/sales/leads">
									<span class="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<path d="M5 12l14 0"></path>
											<path d="M13 18l6 -6"></path>
											<path d="M13 6l6 6"></path>
										</svg>
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>*/}
				<div className="crm-stat-col">
					<div className="card fresh">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{freshleadcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Fresh Leads</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/sales/lead/freshlead${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="crm-stat-col">
					<div className="card follow">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{todayfollowupcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Follow Up for Today</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/sales/notification/today${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="crm-stat-col">
					<div className="card warm">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{warmcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Warm Leads</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/sales/lead/warmleads${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg  className="icon" xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="crm-stat-col">
					<div className="card pending">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{pendingfollowupcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Pending Follow Ups</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/sales/notification/pending${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row crm-report-row">
				<div className="col-md-12">
					<div className="card w-100 crm-big-report-card">
						<div className="card-header border-0 pb-0 d-flex align-items-center justify-content-between flex-wrap gap-2">
							<h4 className="mb-2">
								<i className="ti ti-grip-vertical me-1"></i>Team Performance
							</h4>
							<div classname="dropdown">
								<DatePicker className="form-control" selected={filterteamstartdate} onChange={ handleTeamStatDateRange } startDate={filterteamstartdate} endDate={filterteamenddate} selectsRange isClearable placeholderText="Filter Date" popperPlacement="bottom-end" popperStrategy="fixed" />								
							</div>
						</div>
						<div className="card-body">
							{loader ?
								<ContentLoader />
							:
							<div className="table-responsive crm-report-table-wrap">
								<table className="table table-nowrap mb-0 crm-team-table">
									<thead class="thead-light">
										<tr>
											<th>Teams</th>
											<th>Total Leads</th>
											<th>Warm</th>
											<th>Cold</th>
											<th>Dead</th>
											<th>Application</th>
											<th>Admission</th>
										</tr>
									</thead>
						
									<tbody>
									
									{teamsummary && teamsummary.length > 0 ?
										teamsummary.map(teamdata =>
											(
												<tr className="crm-team-row" key={teamdata.id}>
							
													<td>
														<div className="crm-team-name-wrap">
															<div className="crm-team-avatar">
																{teamdata.name?.slice(0, 2).toUpperCase()}
															</div>
															<div>
																<div className="crm-team-name">
																	<Link to={`/sales/team/${teamdata.id}/callers`}>{teamdata.name}</Link>
																</div>
															</div>
														</div>
													</td>
							
													<td>{teamdata.totalcount} </td>
													<td>{teamdata.warmcount} </td>
													<td>{teamdata.coldcount} </td>
													<td>{teamdata.deadcount} </td>
													<td>{teamdata.applicationcount} </td>
													<td>{teamdata.admissioncount} </td>
												</tr>									  
											
											)
										)
									:
										<tr>
											<td colspan="7" className="text-center">No record found</td>
										</tr>
									}
									</tbody>
								</table>
							</div>
							}
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</Layout>
    )
}

export default Dashboard;
